import { CDN_URL } from '../constants/http-constants';

/**
 * The CDN URL of an uploaded file, built the way the backend's `AssetUrlFactory` does. Upload endpoints
 * answer with the upload id only, so a ref stored in a schemaless document is resolved client-side.
 * No ref yet resolves to `undefined`, never an empty-namespace URL.
 */
export function uploadAssetUrl(namespace: string, ref: string): string;
export function uploadAssetUrl(namespace: string, ref?: string | null): string | undefined;
export function uploadAssetUrl(namespace: string, ref?: string | null): string | undefined {
    return ref ? `${CDN_URL}/${namespace}/${ref}` : undefined;
}
